/**
 * Notification Debugger Utility
 * Use in browser console: notificationDebugger.fullDiagnosis()
 */

import apis from './apis';

export const notificationDebugger = {
  /**
   * Check the currently authenticated user's ID
   */
  async getCurrentUserID() {
    try {
      const response: any = await apis.get('/notifications/debug/current-user');

      if (response?.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      // Silently handle errors
    }
  },

  /**
   * Inspect a specific notification and check if it belongs to the current user
   * @param notificationId - The notification ID to inspect
   */
  async inspectNotification(notificationId: string | number) {
    try {
      const response: any = await apis.get(`/notifications/debug/notification/${notificationId}`);

      if (response?.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      // Silently handle errors
    }
  },

  /**
   * Test the mark-as-read functionality for a specific notification
   * @param notificationId - The notification ID to test
   */
  async testMarkAsRead(notificationId: string | number) {
    try {
      const response: any = await apis.post(`/notifications/debug/test-mark-read/${notificationId}`, {});

      if (response?.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      // Silently handle errors
    }
  },

  /**
   * Full diagnosis - run this to understand the problem
   */
  async fullDiagnosis() {
    try {
      const userData = await this.getCurrentUserID();
      if (!userData) {
        return;
      }

      const response: any = await apis.get('/notifications');
      const notifications = response?.data?.notifications || [];

      if (notifications.length > 0) {
        const firstUnread = notifications.find((n: any) => !n.is_read);
        if (firstUnread) {
          await this.testMarkAsRead(firstUnread.notification_id);
        }
      }
    } catch (error) {
      // Silently handle errors
    }
  }
};

// Make it accessible globally for debugging
(window as any).notificationDebugger = notificationDebugger;
